import { DASHBOARD } from "../../constants/routes";
import { useSelector } from "react-redux";

const HeaderTenkenTitle = () => {
  const appSettings = useSelector((s) => s.app_settings);
  const appName = appSettings.general?.app_name;
  const appVersion = appSettings.general?.app_version;
  return (
    <div className="flex flex-row items-center">
      <a href={DASHBOARD} className="mr-[16px]">
        <h1
          className="text-white font-bold lg:text-[28px] text-2xl 2xl:max-w-[440px] xl:max-w-[400px] lg:max-w-[340px] max-w-[260px] truncate"
          title={appName}
        >
          {appName}
        </h1>
      </a>
      <div className="pt-[8px]">
        <span className="text-white cursor-pointer lg:text-base text-[15px]">
          {appVersion}
        </span>
      </div>
    </div>
  );
};

export default HeaderTenkenTitle;
